<template>
  <div
    :class="['ub-pm', { 'ub-pm--on': selected }]"
    role="radio"
    :aria-checked="selected"
    tabindex="0"
    @click="$emit('input', radioValue)"
    @keydown.enter="$emit('input', radioValue)"
    @keydown.space.prevent="$emit('input', radioValue)"
  >
    <v-radio
      class="d-sr-only"
      :label="label"
      :value="radioValue"
    />

    <!-- Icon / Logo -->
    <span class="ub-pm__icon">
      <slot name="content" />
    </span>

    <!-- Label -->
    <span class="ub-pm__text">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "PaymentMethod",
  props: {
    value: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    radioValue: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
/* ═══════════════════════════════════════════════
   PaymentMethodRadio — Uber Eats style card
   ═══════════════════════════════════════════════ */

.ub-pm {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border: 2px solid $book-grey-lighter;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ub-pm + .ub-pm {
  margin-top: 10px;
}

.ub-pm:hover:not(.ub-pm--on) {
  border-color: $book-grey-light;
}

/* ── Selected ── */
.ub-pm--on {
  border-color: $book-ink;
  box-shadow: 0 0 0 1px $book-ink;
}

/* ── Icon area ── */
.ub-pm__icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-height: 26px;
}

.ub-pm__icon ::v-deep img {
  max-height: 26px;
  object-fit: contain;
}

/* ── Label ── */
.ub-pm__text {
  flex: 1;
  font-family: $book-font-body;
  font-size: 0.9375rem;
  font-weight: 700;
  color: $book-ink;
}

/* ── Focus ── */
.ub-pm:focus-visible {
  outline: 2px solid $book-ink;
  outline-offset: 2px;
  border-radius: 12px;
}
</style>
